<template>
  <div class="fixed top-0 left-0 z-30 w-full">
    <div
      ref="AnnouncementMarquee"
      v-if="announcement_list.length > 0"
      class="relative z-20 w-full h-8 py-1 overflow-hidden text-sm font-medium text-center text-white bg-primary"
    >
      <p
        v-for="(item, item_index) in announcement_list"
        :key="`announcement_${item_index}`"
        class="absolute top-0 right-0 inline-flex items-center justify-end w-auto h-full overflow-hidden whitespace-nowrap"
      >
        <span v-if="item.link == ''">
          {{ item.content }}
        </span>
        <a
          v-else
          :href="item.link"
          target="_blank"
          :key="`announcement_${item_index}`"
          class="flex items-center justify-center w-full h-full overflow-hidden whitespace-nowrap"
        >
          {{ item.content }}
        </a>
      </p>
    </div>
    <div class="relative">
      <div class="w-full relative z-10 h-[70px] bg-white">
        <div
          class="relative flex items-center justify-between w-full h-full pl-5 pr-5 mx-auto md:pr-0 lg:pl-10"
        >
          <router-link to="/" class="relative z-10 py-3 flex items-center h-full">
            <img src="/img/logo.webp" class="block w-40 h-full object-contain" />
          </router-link>
          <button
            aria-label="目錄按鈕"
            @click="$emit('toggle-menu')"
            class="block h-full transition-colors duration-300 md:hidden text-primary hover:md:text-secondary"
          >
            <i v-show="!menu_status" class="icon-menu"></i>
            <i v-show="menu_status" class="icon-close"></i>
          </button>

          <div class="items-center hidden h-full md:flex">
            <ol class="items-center hidden h-full md:flex">
              <li
                v-for="(item, item_index) in menu_list"
                :key="`list_item_${item_index}`"
                class="flex items-center h-full"
              >
                <router-link
                  class="flex items-center h-full px-3 text-sm font-medium transition-colors duration-300 lg:px-5 text-primary hover:md:text-opacity-50"
                  :to="item.link"
                >
                  {{ item.title }}
                </router-link>
              </li>
              <li class="flex items-center h-full ml-4">
                <router-link
                  class="flex items-center justify-center h-full px-10 font-bold text-white transition-all duration-300 bg-primary hover:bg-white hover:text-primary"
                  to="/apply_online/form"
                  >立即試算
                </router-link>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AnnouncementMarquee } from "@/gsap/AnnouncementMarquee";
export default {
  name: "MainHeader",
  data() {
    return {
      menu_list: [
        {
          title: "產品介紹",
          sub_title: "Services",
          link: "/#Services",
        },
        {
          title: "服務流程",
          sub_title: "Flow",
          link: "/#Flow",
        },
        {
          title: "關於我們",
          sub_title: "About",
          link: "/about",
        },
        {
          title: "各大融資項目",
          sub_title: "Glossary",
          link: "/glossary",
        },
        {
          title: "常見問題",
          sub_title: "Question",
          link: "/question",
        },
      ],
      announcement_gsap: null,
    };
  },
  props: {
    menu_status: {
      require: true,
      type: Boolean,
    },
  },
  computed: {
    announcement_list() {
      let list = [];
      for (let i = 0; i < 10; i++) {
        const content = this.$GetColumn(`event_announcement_${i + 1}`);
        const link = this.$GetColumn(`event_announcement_link_${i + 1}`);
        content != ""
          ? list.push({
              content: content,
              link: link,
            })
          : "";
      }
      return list;
    },
  },
  mounted() {
    if (this.announcement_list.length > 0) {
      this.announcement_gsap = new AnnouncementMarquee(
        this.$refs.AnnouncementMarquee
      );
      this.announcement_gsap.setup();
    }
  },
};
</script>
